/* One authoritative Shopify form. No independent cart request or variant state. */
if (!customElements.get('br-purchase-bar')) {
  customElements.define('br-purchase-bar', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-br-variants]').textContent);
      this.choice = this.querySelector('[data-br-choice]');
      this.submit = this.querySelector('[data-br-submit]');
      this.price = this.querySelector('[data-br-price]');
      this.status = this.querySelector('[data-br-status]');
      this.form = () => document.querySelector('main form.f8pr-buy-button');
      const form = this.form();
      if (!form) return;
      this.region = form.closest('.shopify-section');
      if (!this.region) return;
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
      };
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.region, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['value', 'disabled']});
      this.onChange = event => {
        if (event.target.form !== this.form() || !event.target.name.startsWith('options[')) return;
        const desired = this.data.variants.find(v => this.data.options.every((name, i) => {
          const controls = [...this.form().elements].filter(e => (e.name || '').endsWith('-' + name + ']'));
          return controls.some(e => (e.tagName === 'SELECT' || e.checked) && e.value === v.options[i]);
        }));
        this.pending = desired ? desired.id : null;
        this.submit.disabled = true;
        this.schedule();
      };
      document.addEventListener('change', this.onChange);
      this.choice.addEventListener('change', () => {
        const variant = this.data.variants.find(v => v.id === this.choice.value);
        if (!variant) return;
        this.pending = variant.id;
        this.submit.disabled = true;
        this.status.textContent = 'Mise à jour du format…';
        this.data.options.forEach((name, i) => {
          const controls = [...this.form().elements].filter(e => (e.name || '').endsWith('-' + name + ']'));
          const control = controls.find(e => e.tagName === 'SELECT' || e.value === variant.options[i]);
          if (!control) return;
          if (control.tagName === 'SELECT' && control.value !== variant.options[i]) {
            control.value = variant.options[i];
            control.dispatchEvent(new Event('change', {bubbles: true}));
          } else if (control.type === 'radio' && !control.checked) control.click();
        });
        this.schedule();
      });
      this.submit.addEventListener('click', () => {
        this.sync();
        const current = this.form();
        const mainButton = current?.querySelector('button[type="submit"]');
        if (this.submit.disabled || !current || !mainButton || mainButton.disabled) return;
        current.requestSubmit(mainButton);
      });
      this.onVisibility = () => {
        const button = this.form()?.querySelector('button[type="submit"]');
        if (!button) return;
        const r = button.getBoundingClientRect();
        this.hidden = r.top >= 0 && r.bottom <= window.innerHeight;
      };
      window.addEventListener('scroll', this.onVisibility, {passive: true});
      window.addEventListener('resize', this.onVisibility, {passive: true});
      document.documentElement.classList.add('br-purchase-ready');
      this.sync();
    }
    sync() {
      const form = this.form();
      if (!form) { this.submit.disabled = true; return; }
      const id = String(new FormData(form).get('id'));
      const variant = this.data.variants.find(v => v.id === id);
      const mainButton = form.querySelector('button[type="submit"]');
      const shownPrice = form.querySelector('#dynamic-price');
      const compact = s => s.replace(/\s/g, '');
      const settled = variant && (!this.pending || this.pending === id) && (!shownPrice || compact(shownPrice.textContent).includes(compact(variant.price)));
      if (!settled) { this.submit.disabled = true; this.status.textContent = 'Mise à jour du format…'; return; }
      this.pending = null;
      this.choice.value = id;
      this.price.textContent = variant.price;
      this.submit.disabled = !mainButton || mainButton.disabled;
      this.status.textContent = this.submit.disabled ? 'Ce format est indisponible.' : '';
      this.onVisibility();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('change', this.onChange);
      window.removeEventListener('scroll', this.onVisibility);
      window.removeEventListener('resize', this.onVisibility);
      if (this.frame) cancelAnimationFrame(this.frame);
      document.documentElement.classList.remove('br-purchase-ready');
    }
  });
}
